import React from 'react';

import api from '../../../../services';

import AutoComplete from 'material-ui/AutoComplete';

class Design extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            designs: [],
        };

        this.changeAutoComplete = this.changeAutoComplete.bind(this);
        this.chooseAutoComplete = this.chooseAutoComplete.bind(this);
    }

    changeAutoComplete(searchText) {
        this.props.changeField({
            field: 'design.name',
            value: searchText,
            type: undefined,
            cb: () => {
                if (searchText) {
                    api.findVesselDesign(searchText)
                        .then((response) => {
                            if (response.status === 200) {
                                const designs = response.data.data.map(design => ({
                                    name: design.name,
                                    design,
                                }));
    
                                if (!designs.length) {
                                    this.setState({
                                        designs: [],
                                    });
    
                                    this.props.changeField({
                                        field: 'design._id',
                                        value: '',
                                    });
                                } else {
                                    this.setState({
                                        designs: designs,
                                    });
                                }
                            }
                        })
                        .catch((error) => {
                            console.error('Error AutoComplete vessel Design - component', error);
                            return null;
                        });
                } else {
                    this.props.changeField({
                        field: 'design._id',
                        value: '',
                    });
                }
            }
        });
    }

    chooseAutoComplete(updateProperties) {
        this.setState({
            clubs: [],
        });

        this.props.changeField({
            field: 'design',
            value: updateProperties.design,
        });
    }

    render() {
        const { designs } = this.state;
        const { getError, confirmed, modifiedFields, underStyle, design } = this.props;

        return (
            <AutoComplete
                name='pi-club'
                disabled={confirmed}
                dataSource={designs}
                dataSourceConfig={{ text: 'name', value: 'design' }}
                floatingLabelText='Design'
                searchText={design.name}
                onUpdateInput={this.changeAutoComplete}
                onNewRequest={this.chooseAutoComplete}
                filter={AutoComplete.noFilter}
                errorText={getError('design')}
                listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                popoverProps={{
                    canAutoPosition: true,
                }}
                fullWidth

                underlineStyle={modifiedFields && modifiedFields.includes('design.name') ? underStyle : null}
            />
        );
    }
}

export default Design;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/Design.jsx